package com.ijoin.data.model

import kotlinx.serialization.Serializable

@Serializable
data class ChatThread(
    val id: String,
    val otherUserId: String? = null,
    val otherUserName: String? = null,
    val otherUserAvatarUrl: String? = null,
    val lastMessagePreview: String? = null,
    val lastMessageAt: String? = null,
    val unreadCount: Long = 0,
    val group: Boolean = false,
    val title: String? = null,
    val eventId: String? = null,
    val memberCount: Int = 0,
)

@Serializable
data class ChatMessage(
    val id: String,
    val chatId: String,
    val senderId: String,
    val senderName: String? = null,
    val content: String,
    val createdAt: String? = null,
    val outgoing: Boolean = false,
    val read: Boolean = false,
)

@Serializable
data class SendMessageRequest(
    val content: String,
)

@Serializable
data class ChatUserSummary(
    val id: String,
    val displayName: String? = null,
    val username: String? = null,
    val avatarUrl: String? = null,
    val organizer: Boolean = false,
)
